import { useLanguage } from '../hooks/useLanguage';
import { useEffect, useRef } from 'react';

export default function Features() {
  const { t } = useLanguage();
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const items = t('features.items');

  return (
    <section id="features" ref={sectionRef} className="section-padding bg-navy-50/50 relative">
      <div className="w-full">
        {/* Header */}
        <div className="text-center mb-20 reveal">
          <span className="inline-block px-4 py-1.5 rounded-full bg-brand-50 border border-brand-200 text-brand-600 text-sm font-semibold tracking-wider mb-6">
            {t('features.badge')}
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-navy-800">
            {t('features.title')}{' '}
            <span className="text-brand-500">{t('features.titleHighlight')}</span>
          </h2>
          <p className="mt-6 text-xl text-navy-400 max-w-3xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-8">
          {Array.isArray(items) && items.map((item, index) => (
            <div
              key={index}
              className="reveal card-hover group bg-white border border-gray-100 rounded-2xl p-8 hover:border-brand-200"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-14 h-14 rounded-xl bg-brand-50 flex items-center justify-center mb-6 group-hover:bg-brand-500 transition-colors duration-300">
                <span className="text-2xl group-hover:scale-110 transition-transform">{item.icon}</span>
              </div>
              <h3 className="text-xl font-bold text-navy-800 mb-3">
                {item.title}
              </h3>
              <p className="text-navy-400 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
